import React from "react";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import { Tag } from "../Tag/Tag";
import styles from "./BetaTag.module.scss";

export const BetaTag: React.FC<{ tooltip?: string }> = ({ tooltip }) => {
    const tooltipContent =
        tooltip ??
        "This feature is still in beta. Have feedback? Share it with us at feedback@kick.co";

    return (
        <Tooltip content={tooltipContent}>
            <span className={styles.tagContainer}>
                <Tag size="sm" color="neutral" outline>
                    Beta
                </Tag>
            </span>
        </Tooltip>
    );
};
